import React, { useEffect, useRef, useState } from 'react';
import './ShakeImage.scss';

interface ShakeImageProps {
    imageUrl: string;
}

const ShakeImage: React.FC<ShakeImageProps> = ({ imageUrl }) => {
    const [isVisible, setIsVisible] = useState(false);
    const imageRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    // Optional: Stop observing after the first animation
                    observer.unobserve(entry.target);
                }
                else {
                    setIsVisible(false);
                }
            },
            {
                threshold: 0.5, // Adjust as needed
            }
        );

        if (imageRef.current) {
            observer.observe(imageRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className="shake-container">
            <img
                ref={imageRef}
                src={imageUrl}
                className={isVisible ? 'shake' : ''}
            />
        </div>
    );
};

export default ShakeImage;
